module.exports = __webpack_public_path__ + "static/media/careers.2f37b229.svg";